export const BLOCKED_SIGNING_DROP_MESSAGE = 'Cannot add documents. Please create a signing phase.';
